var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.734 8.438C6.008 5.64 8.387 3.5 11.208 3.5a5.5 5.5 0 0 1 5.422 4.562.24.24 0 0 0 .202.19c3.026.232 5.418 2.795 5.418 5.866 0 3.25-2.642 5.882-5.896 5.882H14.75a.75.75 0 0 1 0-1.5h1.604a4.389 4.389 0 0 0 4.396-4.382c0-2.287-1.788-4.199-4.033-4.371a1.738 1.738 0 0 1-1.565-1.433A4 4 0 0 0 11.208 5C9.151 5 7.425 6.563 7.227 8.584a1.69 1.69 0 0 1-1.096 1.42 4.384 4.384 0 0 0-2.881 4.114A4.389 4.389 0 0 0 7.646 18.5h.104A4.25 4.25 0 0 0 12 14.25v-.95L9.99 15.32a.75.75 0 1 1-1.063-1.059l3.276-3.29a.75.75 0 0 1 1.063 0l3.276 3.29a.75.75 0 1 1-1.063 1.059L13.5 13.33v.919A5.75 5.75 0 0 1 7.75 20h-.104c-3.254 0-5.896-2.631-5.896-5.882a5.884 5.884 0 0 1 3.865-5.523.191.191 0 0 0 .12-.157Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploads);
export default __webpack_public_path__ + "static/media/uploads.c474623f0fabdf358a4a3dc8c19838fd.svg";
export { ForwardRef as ReactComponent };